import React, { useState, useEffect, useRef } from 'react';
import Mapa from '../../components/Mapa';
import Historial from '../../components/Historial';
import './PanelGuardia.css';

const ANCHO_MAPA_BASE = 1120;
const ALTO_MAPA_BASE  = 620;

const PanelVisor = ({ rolUsuario }) => {
  const [vista, setVista]   = useState('mapa');
  const [escala, setEscala] = useState(1);
  const contenedorRef = useRef(null); // ← ref en el div EXTERNO sin transform

  useEffect(() => {
    const calcularEscala = () => {
      if (!contenedorRef.current) return;
      // Medimos el contenedor externo real, no window
      const anchoDisponible = contenedorRef.current.offsetWidth - 20;
      setEscala(anchoDisponible < ANCHO_MAPA_BASE
        ? anchoDisponible / ANCHO_MAPA_BASE
        : 1
      );
    };
    const ro = new ResizeObserver(calcularEscala);
    if (contenedorRef.current) ro.observe(contenedorRef.current);
    calcularEscala();
    return () => ro.disconnect();
  }, []);

  const altoEscalado = Math.round(ALTO_MAPA_BASE * escala);

  return (
    <div className="guardia-dashboard">

      {/* BARRA SUPERIOR */}
      <div className="barra-accion" style={{ background:'#002D5C', justifyContent:'space-between', flexWrap:'wrap', gap:'8px', padding:'10px 16px' }}>
        <div style={{ display:'flex', alignItems:'center', gap:'10px', flexShrink:0 }}>
          <img src="/DuocUC-1024x252.png" alt="Logo Duoc" style={{ height:'38px' }} />
          <span style={{ fontWeight:'bold', fontSize:'1rem', color:'white', whiteSpace:'nowrap' }}>VISOR INSTITUCIONAL</span>
          <span style={{
            fontSize:'10px',
            background: rolUsuario?.includes('Director') ? '#30a15f' : '#FFB500',
            padding:'3px 9px', borderRadius:'12px', textTransform:'uppercase',
            letterSpacing:'1px', color:'white', fontWeight:'bold', whiteSpace:'nowrap'
          }}>{rolUsuario}</span>
        </div>
        <div className="controles-vista">
          <button className={`btn-toggle ${vista==='mapa'      ? 'activo':''}`} onClick={() => setVista('mapa')}>MAPA EN VIVO</button>
          <button className={`btn-toggle ${vista==='historial' ? 'activo':''}`} onClick={() => setVista('historial')}>REGISTROS</button>
        </div>
      </div>

      {/* CONTENIDO */}
      <div className="contenido-dinamico">
        {vista === 'mapa' ? (

          /*
            contenedorRef → div EXTERNO: mide el ancho, NO tiene transform
            overflow:hidden → recorta sin activar scrollbar
            height exacta → evita espacio vacío debajo del mapa
          */
          <div
            ref={contenedorRef}
            style={{
              width:          '100%',
              height:         altoEscalado + 16,
              overflow:       'hidden',      /* ← recorta, NO genera scroll */
              display:        'flex',
              justifyContent: 'center',
              alignItems:     'flex-start',
              padding:        '8px',
              boxSizing:      'border-box',
              background:     'white',
            }}
          >
            {/* div INTERNO: SÍ tiene transform, pero Mapa usa portales en body */}
            <div style={{
              transform:       `scale(${escala})`,
              transformOrigin: 'top center',
              transition:      'transform 0.15s ease-out',
              width:           ANCHO_MAPA_BASE,
              flexShrink:      0,
            }}>
              <Mapa />
            </div>
          </div>

        ) : (
          <div className="contenedor-historial-full">
            <Historial />
          </div>
        )}
      </div>
    </div>
  );
};

export default PanelVisor;